import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const BreadcrumbsWrapper = styled.nav`
  position: relative;
  display: flex;
  align-items: center;
  max-width: 100%;
  width: fit-content;

  ${({ theme }) => css`
    column-gap: ${theme.spacings.xs};
  `}
`;

export const BreadcrumbItem = styled(Link).attrs({
  className: 'body-14',
})<{ $isLast: boolean }>`
  max-width: 300px;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme, $isLast }) => css`
    color: ${$isLast
      ? theme.semantic.text.default
      : theme.semantic.link.neutral.text};
    transition-duration: ${theme.tokens.animation.duration.base};

    &:hover {
      color: ${theme.semantic.link.neutral.textHover};
    }

    &:active {
      color: ${theme.semantic.link.neutralPressed};
    }
  `}
`;
